import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { guardRoute } from '../../auth/guard.ts'
import { NAV_PATHS } from '../../navigation/paths.ts'
import { parsePositiveInt } from '../params.ts'
import { officialPeopleRoute } from './people.tsx'

// The address that opens «Invita una persona»: a child of the people list, so the list stays
// mounted under the Panel. Static, so it wins over `/people/$personId`: nobody is called «new».

export interface InviteSearch {
  /** A squad already chosen, so the invitation is a coach's: how the primi passi lead here. */
  readonly teamId?: number
}

export const officialInviteRoute = createRoute({
  getParentRoute: () => officialPeopleRoute,
  path: 'new',
  validateSearch: (search: Record<string, unknown>): InviteSearch => ({
    teamId: parsePositiveInt(search.teamId) ?? undefined,
  }),
  // The list's guard has run already; `guards.test.ts` wants every route to say its own.
  beforeLoad: ({ context, location }) =>
    guardRoute({
      queryClient: context.queryClient,
      requiredRoles: ['club'],
      currentPath: location.href,
    }),
  // The list under the Panel is still the page: the leaf decides what the shell reserves above it.
  staticData: { opensOnHero: true },
  component: lazyRouteComponent(() => import('../../pages/official/invite.tsx')),
})

/** The link the people list takes the path from, instead of respelling it. */
export const officialInviteLink = { to: NAV_PATHS.officialInvite } as const

/** The invitation over the whole list, and a coach's to one squad when it names one. */
export function officialInviteLinkFor(teamId: number | undefined) {
  return { to: NAV_PATHS.officialInvite, search: { filter: 'all', teamId } } as const
}
